








import {Component, Vue, Inject} from 'vue-property-decorator';
import CommonAlert from "@/components/common/CommonAlert.vue";
import CreateMediaSuccessUtil from "@/utils/alerts/CreateMediaSuccessUtil";
@Component({
  components: {CommonAlert}
})
export default class CreateMediaSuccessAlert extends Vue {
  @Inject('createMediaSuccess')
  private createMediaSuccess!: CreateMediaSuccessUtil;

  get show(): boolean {
    return this.createMediaSuccess.isShow();
  }

  private handleClose() {
    this.createMediaSuccess.close();
  }
}
